export default "COMMENT ON $(type:raw) $(thing:name) IS $(comment)\n"